(function() {

   angular.module('e360')
      .directive('gmap', gmapDirective);

   function gmapDirective() {
      return {
         restrict: 'E',
         template: '<div class="map"><div class="map-inner"></div></div>',
         link: gmapDirectiveLink,
         scope: { latLng: '=' }
      };

      function gmapDirectiveLink(scope, element, attrs) {
         scope.$watch('latLng', latLngWatch);

         var marker, map;
         var mapElement = element.find('.map-inner')[0];

         // DOM element might have a 0x0 size when this directive is linking
         // (e.g. gmap directive inside tab directive)
         // map will render as all gray when this happens, resizing browser
         // window or calling google.maps.event.trigger(map, 'resize') will
         // make the map render properly again
         // this short delay seems to be enough to ensure DOM element has size
         setTimeout(function() {
            map = new google.maps.Map(mapElement, {
               zoom: 3,
               center: {lat: 39.8282, lng: -98.5795},
               streetViewControl: false,
               mapTypeId: google.maps.MapTypeId.ROADMAP
            });
         }, 100);

         function latLngWatch(newVal, oldVal) {
            if (!newVal && marker) {
               marker.setMap(null);
               marker = null;
            }

            if (angular.isArray(newVal)) {
               if (!marker) {
                  marker = new google.maps.Marker({
                     clickable: false,
                     map: map
                  });
               }

               var latLng = { lat: newVal[0], lng: newVal[1] };

               map.setCenter(latLng);
               map.setZoom(15);

               marker.setPosition(latLng);
            }
         }
      }
   }

})();